import { endpoint } from 'endpoints/endpoint';

import { DeleteRoomError, DeleteRoomParams, DeleteRoomResult } from './delete-room';

export const deleteRoomFromAdmin = endpoint<DeleteRoomParams, DeleteRoomResult, DeleteRoomError>({
  method: 'POST',
  url: () => '/live-kit/delete-room-from-admin',
});
